import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { ApprovePaymentDto } from 'src/app/domain/models/dto/approvePayment.dto';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { SettlementInfoConfirmComponent } from '../settlement-info-confirm/settlement-info-confirm.component';

@Component({
  selector: 'app-payment-confirm-approved',
  templateUrl: './payment-confirm-approved.component.html',
  styleUrls: ['./payment-confirm-approved.component.scss'],
})
export class PaymentConfirmApprovedComponent implements OnInit {
  boobleModalData: any;
  buttonSend: boolean;

  reasonApprovePayment: string = 'Pago valor integral';
  valueApprovePayment: number = null;

  private readonly notifier: NotifierService;
  public loading: boolean;
  public paymentDifference: number = 0;
  public differenceSign: string = '';

  constructor(
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {}
  changeReasonOption() {
    this.valueApprovePayment = null;
    this.paymentDifference = 0;
    this.differenceSign = '';
  }

  validateValueSend() {
    this.buttonSend =
      this.reasonApprovePayment == 'Valor pago diferente do cotado' &&
      (this.valueApprovePayment == null || this.valueApprovePayment == 0);
    return this.buttonSend;
  }

  onValueChange() {
    const quotedAmount = this.boobleModalData?.quotations[0]?.amountMN || 0;
    const approvedValue = this.valueApprovePayment || 0;
    this.paymentDifference = approvedValue - quotedAmount;

    this.paymentDifference > 0 ? (this.differenceSign = '+') : null;
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  approvePayment() {
    if (!this.validateValueSend()) {
      this.loading = true;

      if (this.reasonApprovePayment === 'Pago valor integral') {
        this.valueApprovePayment =
          this.boobleModalData?.quotations[0]?.amountMN || 0;
      }

      const approveData = new ApprovePaymentDto();
      approveData.ValueApprovedPayment = this.valueApprovePayment;

      this.ordersService
        .approvePayment(this?.boobleModalData.id, approveData)
        .subscribe({
          next: () => {
            this.loading = false;
            this.notifier.notify(
              'success',
              'Pagamento confirmado com sucesso.'
            );
            this.closeModal();
            this.ordersService.updateOrderView();
          },
          error: (err) => {
            this.loading = false;
          },
        });
    }
  }

  openSettlementConfirmModal(order: InboundOrderDto) {
    this.modalService.present(SettlementInfoConfirmComponent, order);
  }
}
